import React from 'react';
import SidebarLayout from "@/components/SidebarLayout.tsx";

// import SidebarLayout from "@/components/SidebarLayout.tsx";
function MainContainer({children}:{
    children: React.ReactNode
}) {
    // return <Sidebar sidebar={<MySidebar/>}
    //     navbar={<Navbar/>}>
    //     {children}
    // </Sidebar>
    // // return (
    // //     <div className={"d-flex flex-column flex-md-row min-vh-100"}>
    // //         <Sidebar />
    // //         <div className={"flex-fill  min-vh-100 shadow"}>
    // //             <div className="p-4">
    // //                 {children}
    // //             </div>
    // //         </div>
    // //     </div>
    // // );
    return <SidebarLayout>
        {children}
    </SidebarLayout>
}

export default MainContainer;
